import { useTheme } from '@mui/material/styles';
import NRCircleLowIcon from './NRCircleLowIcon';
import NRCircleMediumIcon from './NRCircleMediumIcon';
import NRCircleHighIcon from './NRCircleHighIcon';
import NRCircleCriticalIcon from './NRCircleCriticalIcon';
import { CONSTANTS } from '../constants/constants';

const { LOW, MEDIUM, HIGH, CRITICAL } = CONSTANTS.SEVERITIES;

export const SeverityIconComponent = ({ severity }) => {
  const theme = useTheme();
  switch (severity?.toLowerCase()) {
    case LOW:
      return <NRCircleLowIcon height={theme.spacing(4)} width={theme.spacing(4)} />;
    case MEDIUM:
      return <NRCircleMediumIcon height={theme.spacing(4)} width={theme.spacing(4)} />;
    case HIGH:
      return <NRCircleHighIcon height={theme.spacing(4)} width={theme.spacing(4)} />;
    case CRITICAL:
      return <NRCircleCriticalIcon height={theme.spacing(4)} width={theme.spacing(4)} />;
    default:
      return <NRCircleMediumIcon height={theme.spacing(4)} width={theme.spacing(4)} />;
  }
};
export default SeverityIconComponent;
